module.exports = {"DASHBOARD_TITLE":"Dashboard"}


//////////////////
// WEBPACK FOOTER
// ./src/locales/dashboard/dashboard.en.json
// module id = 5Pxd
// module chunks = 0